// extracted by mini-css-extract-plugin
export var arrow = "ArrowButton-module--arrow--9ab0c";
export var backButton = "ArrowButton-module--backButton--0ef2c";
export var content = "ArrowButton-module--content--7756a";
export var nextButton = "ArrowButton-module--nextButton--455cd";
export var position = "ArrowButton-module--position--901c2";
export var small = "ArrowButton-module--small--61bf2";